import { render, staticRenderFns } from "./insurance_type.vue?vue&type=template&id=6ee41e2d&scoped=true"
import script from "./insurance_type.vue?vue&type=script&lang=js"
export * from "./insurance_type.vue?vue&type=script&lang=js"
import style0 from "./insurance_type.vue?vue&type=style&index=0&id=6ee41e2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee41e2d",
  null
  
)

export default component.exports